import { render, staticRenderFns } from "./SurveyMenuItem.vue?vue&type=template&id=b77ee320&scoped=true"
import script from "./SurveyMenuItem.vue?vue&type=script&lang=js"
export * from "./SurveyMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SurveyMenuItem.vue?vue&type=style&index=0&id=b77ee320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77ee320",
  null
  
)

export default component.exports